import React from 'react'

const AuthPageContentContext = React.createContext({
    authPageContent: {},
    setAuthPageContent: () => { },
    footerContent: {},
})

export default AuthPageContentContext